import React from 'react';
import Search from "../../common/Search";
import IOption from "../../../types/option";
import {setPageAction, setRevisionAction} from "../../../store/reducers/searchSlice";
import {getDates, normalize} from "../../../utils/convert";
import {useAppDispatch, useAppSelector} from "../../../store/hooks";
import {wikiAPI} from "../../../api/wp";
import {getCurrentYear} from "../../../utils/content";

const currentYear = getCurrentYear()

const StatisticSearch = () => {
    const dispatch = useAppDispatch()
    const options = useAppSelector(state => state.common.options)

    const [getViewsData, {data: viewsData, isLoading: isViewsDataLoading, isSuccess: isViewsDataSuccess}] = wikiAPI.useGetViewsDataMutation()
    const [getRevisions, {data: revisions, isLoading: isRevisionsLoading, isSuccess: isRevisionsSuccess}] = wikiAPI.useGetRevisionsMutation()
    const [checkRedirect, {data: redirect, isLoading: isRedirectLoading, isSuccess: isRedirectSuccess}] = wikiAPI.useCheckRedirectMutation()

    const isMonthly = () => {
        return (options.revisionsFilterPeriod === 'year' || options.revisionsFilterPeriod === 'lastYear') && !options.revisionsFilterMonthValue
    }

    const chooseHandler = async (option: IOption) => {
        dispatch(setRevisionAction(null))
        let searchValue = option.title

        const {data: pagesData} = await checkRedirect({
            titles: [option.title],
            withRedirect: true
        })
        if (!pagesData || !pagesData.page) return;

        searchValue = normalize(pagesData.page.title)

        dispatch(setPageAction({
            ...pagesData.page,
            slug: searchValue
        }))

        const dates = getDates(options.revisionsFilterPeriod, options.revisionsFilterValue ?? currentYear, options.revisionsFilterMonthValue)

        await getViewsData({
            query: searchValue,
            dateFrom: dates.from,
            dateTo: dates.to,
            type: 'daily'// isMonthly() ? 'monthly' : 'daily'
        })

        getRevisions({
            pageId: pagesData.page.id,
            limit: options.revisionsStep
        })
    }

    return (
        <Search onChoose={chooseHandler} />
    );
};

export default StatisticSearch;